import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Erhverv from './pages/Erhverv';
import Privat from './pages/Privat';
import Tagrende from './pages/Tagrende';
import GalleryPage from './pages/GalleryPage';
import Contact from './pages/Contact';
import Error404 from './pages/Error404';
import Error403 from './pages/Error403';

export default function App() {
  return (
    <>
      {/* Scroll Restoration ved sideskift */}
      <ScrollToTop />

      <div className="flex min-h-screen flex-col bg-slate-50 text-slate-800 antialiased">
        {/* Header / Navigation */}
        <Header />

        {/* Hovedindhold */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/ydelser/erhvervs-vinduespolering" element={<Erhverv />} />
            <Route path="/ydelser/privat-vinduespolering" element={<Privat />} />
            <Route path="/ydelser/tagrende-rens" element={<Tagrende />} />
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}
